/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  selectors for the cityGuideNeighborhood section of currentSearch
 */

import type { CityGuideNeighborhood, CityGuideNeighborhoodMetaType, State } from '@zcode/state-type'
import { compose } from 'redux'

// importing this from index.js crashes React
const selectCurrentSearch = (state: State) => state?.currentSearch

export const selectCityGuideNeighborhood = compose(
  (currentSearch) => currentSearch?.cityGuideNeighborhood?.data as CityGuideNeighborhood,
  selectCurrentSearch
)

export const selectCityGuideNeighborhoodMeta = compose(
  (currentSearch) => currentSearch?.cityGuideNeighborhood?.meta as CityGuideNeighborhoodMetaType,
  selectCurrentSearch
)

export const selectCityGuideNeighborhoodIsLoading = compose(
  (meta) => meta?.fetching,
  selectCityGuideNeighborhoodMeta
)

export const selectCityGuideNeighborhoodError = compose(
  (meta) => meta?.error,
  selectCityGuideNeighborhoodMeta
)

export const selectCityGuideNeighborhoodKey = compose(
  (meta) => meta?.key,
  selectCityGuideNeighborhoodMeta
)
